import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@blimo/ui';

/**
 * Previous/next page for paginated lists („Seite 2 von 5“).
 * @param {{ page: number, lastPage: number, onPage: (page: number) => void, summary?: import('react').ReactNode, always?: boolean }} props
 */
export function Pager({ page, lastPage, onPage, summary, always = false }) {
  if (lastPage <= 1 && !always) return null;
  return (
    <div className="flex items-center justify-between gap-2 text-[0.8125rem]">
      <span className="text-muted-foreground tabular-nums">
        Seite {page} von {lastPage}
        {summary}
      </span>
      {lastPage > 1 && (
        <div className="flex gap-1.5">
          <Button variant="outline" size="icon-sm" disabled={page <= 1} aria-label="Vorherige Seite" onClick={() => onPage(page - 1)}>
            <ChevronLeft aria-hidden="true" />
          </Button>
          <Button variant="outline" size="icon-sm" disabled={page >= lastPage} aria-label="Nächste Seite" onClick={() => onPage(page + 1)}>
            <ChevronRight aria-hidden="true" />
          </Button>
        </div>
      )}
    </div>
  );
}
